import { useState, useEffect } from "react";
import Layout from "../../../components/layout/Layout";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  ActionContainer,
  AddUser,
  DataGridContainer,
  DataGridWrapper,
  OrderMessageContainer,
  OrderMessageLabel,
  OrderMessageTextArea,
  SaveMessageButton,
} from "./style";
import { Link, useParams } from "react-router-dom";
import { getProductsColumns } from "./productsForm";
import { getEventProducts, getEvent, updateEventMeta } from "../../../api/eventsService";
import { toast } from "react-toastify";
import {
  formatProductCurrencyLabel,
  getCurrencySymbol,
  getProductCurrency,
  getProductTax,
} from "../../../util/eventProductSales";
import { useAuth } from "../../../hooks/useAuth";

type ListType = "User" | "Product" | "Order";

const Products = () => {
  const type: ListType = "Product"
  const { id }: any = useParams();
  const { isAdmin } = useAuth();

  // const data = useData(type);
  const [data, setData] = useState<any[]>([]);
  const [event, setEvent] = useState<any>(null);
  const [orderMessage, setOrderMessage] = useState<string>("");

  const productCurrencyCode = getProductCurrency(event);
  const productCurrencySymbol = getCurrencySymbol(productCurrencyCode);
  const productTax = getProductTax(event);
  const gridColumns = getProductsColumns(productCurrencySymbol);

  const handleSaveOrderMessage = async () => {
    try {
      await updateEventMeta(id, { order_message: orderMessage });
      toast.success("Order message saved successfully", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error: any) {
      toast.error(error?.message || "Failed to save order message", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handleDelete = async (id: string) => {
    try {

    } catch (err) {
      console.log(err);
    }
  };
  const actions: GridColDef[] = [
    {
      field: "action",
      headerName: "Action",
      width: 160,
      renderCell: (params) => {
        return (
          <ActionContainer>
            <Link
              to={`/events/${id}/products/${params.row.id}`}
              state={{ ...params.row }}
              style={{ textDecoration: "none" }}
            >
              <button className="btn viewBtn">View</button>
            </Link>
            {isAdmin && (
            <button
              onClick={() => handleDelete(params.row.id)}
              className="btn deleteBtn"
            >
              Delete
            </button>
            )}
          </ActionContainer>
        );
      },
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const res = await getEventProducts(id);
      if (res) {
        setData(res);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const fetchEvent = async () => {
      const eventData = await getEvent(id);
      if (eventData && typeof eventData === 'object' && !Array.isArray(eventData)) {
        setEvent(eventData);
        setOrderMessage(eventData?.meta?.order_message ?? "");
      }
    };
    fetchEvent();
  }, [id]);
  return (
    <Layout>
      <AddUser>
        <div>
          <h1 className="title" style={{ textAlign: 'left' }}>Event Products</h1>
          {event && (
            <p style={{ margin: 0, padding: '0 12px 8px', fontSize: 14, color: '#555' }}>
              Product order currency: <strong>{formatProductCurrencyLabel(event)}</strong>
              {' · '}
              Tax: <strong>{productTax}%</strong>
              {' · '}
              <Link to={`/events/${id}`} style={{ color: '#5949d1' }}>Edit on event</Link>
            </p>
          )}
        </div>
        {isAdmin && (
        <Link
          to={`/events/${id}/products/new`}
          state={{ type }}
          style={{ textDecoration: "none" }}
        >
          <button className="add">Add {type}</button>
        </Link>
        )}
      </AddUser>
      <DataGridWrapper>
        <DataGridContainer>
          <DataGrid
            style={{ backgroundColor: "white" }}
            rows={data}
            columns={
              gridColumns.concat(actions)
            }
            pageSize={10}
            rowsPerPageOptions={[10]}
          // checkboxSelection
          />
        </DataGridContainer>
        <OrderMessageContainer>
          <OrderMessageLabel htmlFor="order_message">Order message (default for new orders)</OrderMessageLabel>
          <OrderMessageTextArea
            id="order_message"
            placeholder="Enter default message for orders..."
            value={orderMessage}
            onChange={(e) => setOrderMessage(e.target.value)}
          />
          <SaveMessageButton onClick={handleSaveOrderMessage}>
            Save Order Message
          </SaveMessageButton>
        </OrderMessageContainer>
      </DataGridWrapper>
    </Layout>
  );
};

export default Products;
